module.exports = __webpack_public_path__ + "static/media/Pic-0461.94c4f17e.jpg";